import createImmutablePathReducer from "../../create-immutable-path-reducer";
import merge from "../immutable/merge";
export default createImmutablePathReducer(merge);
